// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ContactForm_wrap__3Zgyy","label":"ContactForm_label__jOxBL","input":"ContactForm_input__3tfwE","button":"ContactForm_button__2tcPA"};